import React from 'react';
import ContentPostDetail from '../components/content/ContentPostDetail';
import { articlesService } from '../api';
import './InfoPages.css';

const ArticleDetailPage = () => (
    <div className="info-page">
        <ContentPostDetail service={articlesService} basePath="/articles" />
    </div>
);

export default ArticleDetailPage;
